<template>
  <div id="auth-layout">
    <router-view/>
  </div>
</template>

<script>

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "AuthLayout",
  }
</script>

<style lang="scss" scoped>
  @import "./../../../scss/variables";

  #auth-layout{
    height: $auth-layout-height;
  }
</style>
